import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  Button,
  Divider,
  Grid,
  GridColumn,
  GridRow,
  Icon,
  Image,
  Label,
  Modal
} from 'semantic-ui-react';
import facebookLogo from "../../components/Layout/facebook.png";
import instagramLogo from "../../components/Layout/instagram.png";
import draxLogo from "../../components/Layout/logo2.png";
import naverLogo from "../../components/Layout/naver.png";

type Step = '접수중' | '접수완료' | '배정완료';

interface ReceiptDetailProps {
  ERP_number : string;
  model : number;
  model_info : string;
  model_name : string;
  product_name  : string;
  receipt : number;
  serial_number : string;
  symptom : string;
  symptom_detail : string;
  cancel: string;
  receipt_step: Step;

}

interface ReceiptCheckProps {
  id: string;
  ERP_receipt_code: string;
  address: string;
  company_register_number:  string;
  customer: string;
  email: string;
  is_info_agree : boolean;
  phone_number: string;
  receipt_category: string;
  receipt_name: string;
  receiption_date: string;
  zone_code: string;
  receiptNumber: string;
  get_receipted_number : number;
  is_finished: boolean;
  receiptDetail: ReceiptDetailProps[];
}

const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;

const fetchUploadedFiles = async (id: string, ERP_number: string) => {
  try {
    const response = await axios.get(`${apiEndpoint}/receiption/api/viewUploadedFile/`, {
      headers: { 'Content-Type': 'multipart/form-data' },
      params: { id, ERP_number }
    });
    return response.data.files;
  } catch (error) {
    console.error('Error fetching uploaded files:', error);
    throw error;
  }
}

const ReceiptCheckDetail = () => {
  const navigate = useNavigate();
  const [receiptList, setReceiptList] = useState<ReceiptCheckProps[]>();
  const id = useParams();
  const {state} = useLocation()
  const [RerenderTrigger, setRerenderTrigger] = useState<number>(0)
  const [uploadIndexDict, setUploadIndexDict] = useState<{[key: string]: boolean}>({}); // 업로드된 파일 인덱스 관리용 딕셔너리
  const [openModal, setOpenModal] = useState<boolean>(false); // 모달 상태 관리
  const [uploadedFileNumber, setUploadedFileNumber] = useState<number>(0);
  const [ERP_number, setERP_number] = useState<string>(''); // ERP 번호 상태 관리
  const [uploadedFileUrls, setUploadedFileUrls] = useState<string[]>([]); // 업로드된 파일 URL 상태 관리

  useEffect(() => {
    if (state && state.isValid){
      axios.get(`${apiEndpoint}/receiption/api/receiptCheck/`, {params: {id: id.receiptId}})
        .then(response => {
          // console.log(response.data)
          setReceiptList(response.data)
          const receiptDetails = response.data.receiptDetail;

          const initialDict = receiptDetails.reduce((acc:{[key: string]: boolean}, item:ReceiptDetailProps) => {
            acc[item.ERP_number] = false;
            return acc;
          }, {} as { [key: string]: boolean });
          setUploadIndexDict(initialDict); // 초기 딕셔너리 설정
        })
        .catch(error => {
          console.error('API 호출 중 오류 발생:', error);
        });
    }
    },[]);

  useEffect(() => {
    if (id.receiptId && ERP_number) {
      fetchUploadedFiles(id.receiptId, ERP_number).then(files => {
          setUploadedFileNumber(files.length); // 업로드된 파일의 개수 설정
          setUploadedFileUrls(files); // 파일 URL 설정
        }).catch(error => {
          console.error('Error fetching uploaded files:', error);
        });
    }
  }, [ERP_number, id.receiptId]);

    interface ProgressBarProps {
      currentStep: Step; // 현재 단계
    }

    const steps: Step[] = ['접수중', '접수완료', '배정완료'];

    const ProgressBar: React.FC<ProgressBarProps> = ({ currentStep }) => {
      return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {steps.map((step, index) => {
            const isActive = steps.indexOf(currentStep) >= index; // 현재 또는 이전 단계
            return (
              <React.Fragment key={step}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <div
                    style={{
                      width: 25,
                      height: 25,
                      borderRadius: '50%',
                      backgroundColor: isActive ? '#4caf50' : '#ccc', // 활성화된 단계는 녹색
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#fff',
                      fontWeight: 'bold',
                    }}
                  >
                    {index + 1}
                  </div>
                  <span style={{ marginTop: 4, color: isActive ? '#4caf50' : '#ccc' , fontSize:'0.85rem'}}>
                    {step}
                  </span>
                </div>
                {index < steps.length - 1 && (
                  <div
                    style={{
                      width: 40,
                      height: 4,
                      backgroundColor: isActive ? '#4caf50' : '#ccc', // 활성화된 단계는 녹색
                      margin: '0 8px',
                    }}
                  ></div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      );
    };




  const genReceiptDetailTable = () => {

    const handleUploadClick = (key:string, e:any) => {
      document.getElementById(`image-file-${key}`)?.click(); // 모달 닫고 파일 업로드 창 띄움
    };

    const uploadFile = async (fileList: FileList, receipt_id:number, ERP_number:string) => {
      const isConfirmed = window.confirm(
        `총 ${fileList.length}개의 파일을 업로드하시겠습니까?`
      );

      if (!isConfirmed) {
        console.log('파일 업로드가 사용자에 의해 취소되었습니다.');
        return;
      }


      const formData = new FormData();
      formData.append('id', String(receipt_id));
      formData.append('ERP_number', ERP_number);

      for (let i = 0; i < fileList.length; i++) {
        formData.append('files', fileList[i]);
      }

      try {
        const response = await axios.post(`${apiEndpoint}/receiption/api/uploadAdditionalSymptomFile/`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        console.log('파일 업로드 성공:', response.data)

        alert('파일이 정상적으로 업로드되었습니다.');

        setTimeout(() => {
          window.location.reload();
        }, 250);

        setRerenderTrigger(prev => prev + 1); // 렌더링 트리거 업데이트
      } catch (error) {
        console.error('파일 업로드 실패:', error);
      }
    }

    const handleSelectFileList = (e: React.ChangeEvent<HTMLInputElement>, receipt_id:number, ERP_number:string) => {
      uploadIndexDict[ERP_number] = true; // 업로드된 파일 인덱스 딕셔너리 업데이트

      uploadFile(e.target.files as FileList, receipt_id, ERP_number)

    }

    const handleViewUploadedFileClick = async (id: number, ERP_number:string) => {
      setERP_number(ERP_number)
      setOpenModal(true)
      }

    const genReceiptDetail = (receiptList: ReceiptCheckProps[]) => {
      const receiptDetailList = receiptList[0].receiptDetail
      const filteredReceiptDetailList = receiptDetailList.filter((value) => value.cancel === null) // 취소요청 된 건에대해서는 고객에게 보여주지 않음.
      const receiptDetail = filteredReceiptDetailList.map((data:ReceiptDetailProps, index:number) => {
        const receipt_step: Step = !data.receipt_step.includes('배정완료') ? data.receipt_step : data.receipt_step.split('(')[0] as Step
        return <>
          <GridRow className={`pb-1 pt-4`}>
            <GridColumn textAlign='left'>
              <Label><Icon name='tag'></Icon>접수번호 {index+1}</Label>
            </GridColumn>
          </GridRow>

          <GridRow className={`py-1`}>
            <GridColumn width={5} textAlign='center'>
              모델
            </GridColumn>
            <GridColumn width={11} textAlign='center'>
              ({data.product_name}){data.model_name}
            </GridColumn>
          </GridRow>

          <GridRow className='py-1'>
            <GridColumn width={5} textAlign='center'>
              옵션
            </GridColumn>
            <GridColumn width={11} textAlign='center'>
              {data.model_info? data.model_info : '(없음)'}
            </GridColumn>
          </GridRow>

          <GridRow className='py-1'>
            <GridColumn width={5} textAlign='center'>
              증상분류
            </GridColumn>
            <GridColumn width={11} textAlign='center'>
              {data.symptom}
            </GridColumn>
          </GridRow>

          <GridRow className='py-1'>
            <GridColumn width={5} textAlign='center'>
              상세증상
            </GridColumn>
            <GridColumn width={11} textAlign='center'>
              {data.symptom_detail}
            </GridColumn>
          </GridRow>

          <GridRow className='py-1'>
            <GridColumn width={5} textAlign='center'>
              접수단계
            </GridColumn>
            <GridColumn width={11} textAlign='center'>
              <ProgressBar currentStep={receipt_step} />
            </GridColumn>
          </GridRow>

          <GridRow className='py-1'>
            <GridColumn width={5} textAlign='center'>
            <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center", flexDirection: "column" }}>
              <div>
              사진/영상 추가
              </div>
              <div
                className="view-file-link" // hover 효과를 위한 클래스
                onClick={() => handleViewUploadedFileClick(data.receipt, data.ERP_number)}
              >
                (기존 업로드 파일 보기)
              </div>
            </div>
            </GridColumn>
            <GridColumn width={11} textAlign='center'>
            <div className="information2 align-center pb-2" style={{ display: "flex", justifyContent: "space-around", alignItems: "center" }}>
              <Button size='tiny' color='grey' type="button" icon onClick={(e) => handleUploadClick(data.ERP_number, e)}>
                <Icon name='file outline'></Icon> 증상 업로드
              </Button>
              <input
                type="file"
                multiple
                accept="image/*, video/*"
                id={`image-file-${data.ERP_number}`}
                style={{ display: "none" }}
                onClick={(e) => { (e.target as HTMLInputElement).value = ''; }}
                onChange={(e) => handleSelectFileList(e, data.receipt, data.ERP_number)}
              />
            </div>
            </GridColumn>
          </GridRow>
        </>
      })

      return receiptDetail
    }


    if (receiptList)

      return <>
          <GridRow className={`pb-1 pt-3`}>
            <GridColumn textAlign='left'>
              <Label><Icon name='user'></Icon>고객정보</Label>
            </GridColumn>
          </GridRow>
          <GridRow className='py-1'>
            <GridColumn width={5} textAlign='center'>
              상호/ 업체명
            </GridColumn>
            <GridColumn width={11} textAlign='center'>
              {receiptList[0]?.customer}
            </GridColumn>
          </GridRow>

          <GridRow className='py-1'>
            <GridColumn width={5} textAlign='center'>
              접수자명
              </GridColumn>
              <GridColumn width={11} textAlign='center'>
                {receiptList[0]?.receipt_name}
              </GridColumn>
            </GridRow>

          <GridRow className='py-1'>
            <GridColumn width={5} textAlign='center'>
              전화번호
            </GridColumn>
            <GridColumn width={11} textAlign='center'>
              {receiptList[0]?.phone_number}
            </GridColumn>
          </GridRow>

          <GridRow className='py-1'>
            <GridColumn width={5} textAlign='center'>
              사업자번호
            </GridColumn>
            <GridColumn width={11} textAlign='center'>
              {receiptList[0]?.company_register_number}
            </GridColumn>
          </GridRow>

          <GridRow className='py-1'>
            <GridColumn width={5} textAlign='center'>
              email
            </GridColumn>
            <GridColumn width={11} textAlign='center'>
              {receiptList[0]?.email}
            </GridColumn>
          </GridRow>

          <GridRow className='py-1'>
            <GridColumn width={5} textAlign='center'>
              주소
            </GridColumn>
            <GridColumn width={11} textAlign='center'>
              {receiptList[0]?.address}({receiptList[0]?.zone_code})
            </GridColumn>
          </GridRow>

          <Divider className='mb-1'>
            {/* <Header as='h5'>
              접수모델
            </Header> */}
          </Divider>
          {genReceiptDetail(receiptList)}
      </>

  }

  // 비디오 파일 확장자 목록
  const VIDEO_EXTENSIONS = ['mp4', 'mov', 'webm', 'ogv'];

  const genFileViewer = (uploadedFileUrls: string[]) => {
    // 이미지와 비디오에 공통으로 적용할 스타일 객체
    const mediaStyle = {
      height: '300px',       // 원하는 높이로 고정
      objectFit: 'cover' as const,  // 비율을 유지하며, 지정된 크기에 꽉 차도록 표시
      borderRadius: '4px',   // Semantic UI의 'rounded'와 유사한 효과
    };

    const indexBadgeStyle = {
      position: 'absolute' as const, // 부모 요소를 기준으로 위치를 잡음
      top: '1rem',                   // 부모의 padding 값과 동일하게 설정
      left: '1rem',                  // 부모의 padding 값과 동일하게 설정
      backgroundColor: 'rgba(0, 0, 0, 0.6)', // 반투명한 검은색 배경
      color: 'white',
      width: '25px',
      height: '25px',
      borderRadius: '50%', // 원형으로 만듦
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontWeight: 'bold',
      zIndex: 1, // 다른 요소들 위에 표시되도록 함
    };

    return uploadedFileUrls.map((url, index) => {
      // URL의 마지막 부분을 잘라 확장자를 소문자로 가져옵니다.
      const extension = url.split('.').pop()?.toLowerCase();

      // 비디오 확장자 목록에 포함되는지 확인합니다.
      const isVideo = extension && VIDEO_EXTENSIONS.includes(extension);

      return (
        <Grid.Row key={`${url}-${index}`}>
          {/* Grid.Column에 Flexbox 스타일을 적용하여 내부 아이템을 중앙 정렬합니다. */}
          <Grid.Column
            style={{
              display: 'flex',
              justifyContent: 'center', // 가로 중앙 정렬
              alignItems: 'center',     // 세로 중앙 정렬
              border: '1px solid #ddd',  // 옅은 회색의 1px 실선 테두리
              padding: '1rem',            // 테두리와 콘텐츠 사이의 안쪽 여백
              borderRadius: '8px',        // 테두리 모서리를 둥글게
              position: 'relative',
            }}
          >
            <div style={indexBadgeStyle}>
              {index + 1}
            </div>
            {isVideo ? (
              <video style={mediaStyle} controls>
                <source src={url} type={`video/${extension}`} />
                브라우저가 비디오 태그를 지원하지 않습니다.
              </video>
            ) : (
              <Image src={url} style={mediaStyle} />
            )}
          </Grid.Column>
        </Grid.Row>
      );
    });
  };

  return (
    <div
      style={{ display: "flex", justifyContent: "center", alignItems: "center",}} >
      <div style={{ width: "90%", maxWidth: "700px", }}>
        {/* header */}
        <h1 className="align-center my-4" style={{cursor:'pointer'}} onClick={() => navigate('/')}>내 접수내역 확인</h1>

        {/* content */}
        <div className="ui divider"/>
        <h2 className='p-2'>상세접수내역</h2>
        <div className="card p-4">

        <Grid columns={2} divided>
          {state && state.isValid ? (genReceiptDetailTable()) : (<div style={{"color":"red"}}>적절한 접근방법이 아닙니다!!</div>)}
        </Grid>

        </div>
        {/* 업로드 가이드 모달 */}
        <Modal
          size="small"
          open={openModal}
          onClose={() => setOpenModal(false)}
          >
          <Modal.Header>업로드 사진/영상({uploadedFileNumber})</Modal.Header>
          <Modal.Content scrolling>
            <Grid rows={uploadedFileNumber} stackable padded>
              {genFileViewer(uploadedFileUrls)}
            </Grid>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={() => setOpenModal(false)}>취소</Button>
          </Modal.Actions>
        </Modal>

        <div className='px-5 align-center' >
          <Button size='big' color='orange' onClick={() => navigate('/receipt')}>뒤로</Button>
        </div>

        {/* footer */}
        <div className="ui divider"/>
        <div className="information2 row" style={{ display: "flex" }}>
          <div
            style={{
              width: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: '0',
              paddingTop: '0',
              paddingBottom: '1rem'
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
              <div style={{ flex: '0 0 80%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80%' }}>
                <img
                  src={draxLogo}
                  alt="Drax"
                  className="py-1"
                  style={{ width: '100%', height: 'auto', maxWidth: '200px', cursor: 'pointer' }}
                  onClick={() => window.open('https://www.draxfit.com/', '_blank')}
                />
              </div>
              <div style={{ flex: '0 0 20%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '20%' }}>
                <img
                  src={naverLogo}
                  alt="Naver"
                  className="px-2"
                  style={{ width: '40px', height: '30px', cursor: 'pointer' }}
                  onClick={() => window.open('https://blog.naver.com/draxfit_official/', '_blank')}
                />
                <img
                  src={instagramLogo}
                  alt="Instagram"
                  className="px-2"
                  style={{ width: '40px', height: '30px', cursor: 'pointer' }}
                  onClick={() => window.open('https://www.instagram.com/draxfit_official/', '_blank')}
                />
                <img
                  src={facebookLogo}
                  alt="Facebook"
                  className="px-2"
                  style={{ width: '40px', height: '30px', cursor: 'pointer' }}
                  onClick={() => window.open('https://www.facebook.com/DRAXFIT/', '_blank')}
                />
              </div>
            </div>
          </div>
          <div
            style={{
              width: "50%",
              textAlign: 'left',
              fontSize: '0.75rem',
              paddingBottom: '1.5rem',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}
          >
            <div style={{ fontWeight: 'bold', fontSize: '1.5rem', marginBottom: '8px' , marginTop: '27px'}}>주식회사 디랙스</div>
            <div style={{ marginBottom: '0.5px' }}>본사/제1공장 : 경기 안양시 만안구 전파로62번길 26</div>
            <div style={{ marginBottom: '0.5px' }}>제2공장 : 경기 안양시 만안구 전파로 48</div>
            <div style={{ marginBottom: '0.5px' }}>제3공장 : 경기 안양시 만안구 덕천로72번길 85</div>
            <div style={{ marginBottom: '0.5px' }}>사업자등록번호 123-81-70002</div>
            <div style={{ marginBottom: '0.5px' }}>TEL: 031-459-8530 / FAX: 031-459-8531</div>
          </div>
        </div>
        {/* footer */}
      </div>
    </div>
  )
}

export default ReceiptCheckDetail;